export default function tpl(params) {
	return params.texts.noResultLabel;
}
